<div class="usheru-logo">
  <a [href]="linkSig()" target="_blank" (click)="onPoweredByClicked()" class="powered">
    <div>
      <span [attr.data-translate]="'public.footer.link.powered'">{{
        'public.footer.link.powered' | translate: { placeholder: 'powered by' }
      }}</span
      ><span class="usheru-name">usheru</span>
    </div>
  </a>
</div>
